import React from 'react';

function BuildingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <g clipPath="url(#clip0_4214_34017)">
        <path
          fill="#049B56"
          d="M7 14.652a1 1 0 01-1 1H5a1 1 0 110-2h1a1 1 0 011 1zm4-1h-1a1 1 0 000 2h1a1 1 0 100-2zm-5 4H5a1 1 0 000 2h1a1 1 0 100-2zm5 0h-1a1 1 0 000 2h1a1 1 0 100-2zm-5-12H5a1 1 0 000 2h1a1 1 0 100-2zm5 0h-1a1 1 0 000 2h1a1 1 0 100-2zm-5 4H5a1 1 0 000 2h1a1 1 0 100-2zm5 0h-1a1 1 0 000 2h1a1 1 0 100-2zm13 1v9a5.006 5.006 0 01-5 5H5a5.005 5.005 0 01-5-5v-14a5.006 5.006 0 015-5h6a5.006 5.006 0 015 5h3a5.006 5.006 0 015 5zm-19 12h9v-17a3 3 0 00-3-3H5a3 3 0 00-3 3v14a3 3 0 003 3zm17-12a3 3 0 00-3-3h-3v15h3a3 3 0 003-3v-9zm-3 3a1 1 0 100 2 1 1 0 000-2zm0 4a1 1 0 100 2 1 1 0 000-2zm0-8a1 1 0 100 2 1 1 0 000-2z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4214_34017">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(0 .652)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default BuildingIcon;
